import React, { useState } from 'react'
import "./Profile.scss"
import editicon from "../../../assets/icons/editicon.svg"
import profilepic from "../../../assets/images/profilepic.png"
import EditProfile from './EditProfile'
const Profile = () => {
    const [edit, setEdit] = useState(false);
    const toggle_edit = () => {
        setEdit(true);
    }
  return (
    <>
        <div className='customScroller-transparent'>
       {edit ? (<> <EditProfile />   </>) :(<><div className='myprofile '>
        <div className="profiletop  ">
            <h2>
            My Profile
            </h2>
           <div onClick={toggle_edit} className="editprofile">
            <div>
                <img src={editicon} alt="" />
            </div>
            <div >
                <p >
                Edit </p>
            </div>
           </div>
        </div>
      <div className="profilepic">
        <div className="personalinfo">
            <h2>
            Jack Adoms
            </h2>
            <p>
            Manager
            </p>
            <p>
            Los Angeles, California, USA
            </p>
        </div>
        <div className="picside">
            <img src={profilepic} alt="" />
        </div>
      </div>
      <div className="personaldata">
        <div className="information">
            <h1>Personal Information</h1>
            <div className="infocont">
            <div className="leftinfo">
                <h2>First Name</h2>
                <p>
                    Jack
                </p>
                <h2>Email Address</h2>
                <p>jackadmos@gmail.com</p>
            </div>
            <div className="rightinfo">
                <h2>Last Name</h2>
                <p>Adoms</p>
                <h2>Phone</h2>
                <p>
                (213) 555-1239
                </p>
            </div>
            </div>
           
        </div>
        <div className="information">
            <h1>Address</h1>
            <div className="infocont">
            <div className="leftinfo">
                <h2>Country</h2>
                <p>
                United States of America
                </p>
                <h2>City/State</h2>
                <p>California, USA</p>
            </div>
            <div className="rightinfo">
                <h2>Postal Code</h2>
                <p>ERT 62574</p>
                
            </div>
            </div>
           
        </div>
        
      
        
      </div>
      
      <div className="biodata">
      <div className="bio">
            <h1>Social media accounts</h1>
            <div className="biocont">
            <div className="leftbio">
                <h2>Facebook</h2>
                <p>
                www.facebook.com
                </p>
                <h2>Linkedin</h2>
                <p>www.linkedin.com</p>
            </div>
            <div className="rightbio">
                <h2>Instagram</h2>
                <p>www.instagram.com</p>
                <h2>X</h2>
                <p>
                www.x.com
                </p>
            </div>
            </div>
         
           
        </div>
        <div className="social">
        <h2>
        Bio
        </h2>
        <p>
        Proin ac tortor pulvinar, lacinia mi vel, rutrum justo. 
        Sed viverra sed mauris id accumsan. Integer cursus 
        purus quis enim tempus eleifend vel vitae justo. In 
        lacus elit, condimentum at dui in, tempor placerat 
        diam. Donec eget porttitor diam, eget eleifend felis. 
        Sed maximus ligula eget quam.  
        </p>
      </div>
      </div>
      
      </div></>) } 
      </div>
    
     </>
  
  )
}

export default Profile
